import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { searchFormItems } from './config';
import { PAGE_URL } from '@/api/report/operationRecord/operationRecord';
import { XTable } from '@/components/index';
import { formatterDate } from '@/utils/common';

import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'OperationRecord',
  setup: function setup(__props) {
    var tableInstance = ref();
    var searchData = {};
    var operationTypeList = ref([]);
    var headerButton = [];
    function search(formDara) {
      var _tableInstance$value;
      searchData = formDara;
      (_tableInstance$value = tableInstance.value) === null || _tableInstance$value === void 0 || _tableInstance$value.load(formDara);
    }
    function reset() {
      var _tableInstance$value2;
      searchData = {};
      (_tableInstance$value2 = tableInstance.value) === null || _tableInstance$value2 === void 0 || _tableInstance$value2.load({});
    }
    function tableReLoad() {
      var _tableInstance$value3;
      (_tableInstance$value3 = tableInstance.value) === null || _tableInstance$value3 === void 0 || _tableInstance$value3.load(searchData);
    }
    return function (_ctx, _cache) {
      var _component_XSearchForm = _resolveComponent("XSearchForm");
      var _component_ElTableColumn = _resolveComponent("ElTableColumn");
      var _component_XAppLayout = _resolveComponent("XAppLayout");
      return _openBlock(), _createBlock(_component_XAppLayout, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_XSearchForm, {
            ref: "searchForm",
            items: _unref(searchFormItems),
            onSearch: search,
            onReset: reset
          }, null, 8, ["items"]), _createVNode(_unref(XTable), {
            ref_key: "tableInstance",
            ref: tableInstance,
            url: _unref(PAGE_URL),
            "show-index": "",
            selectable: false,
            "header-buttons": headerButton,
            "el-table-props": {
              border: true
            }
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_ElTableColumn, {
                label: "锚位",
                prop: "anchorPoint",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "操作类型",
                prop: "operationType",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "操作者",
                prop: "nickname",
                align: "center"
              }), _createVNode(_component_ElTableColumn, {
                label: "操作时间",
                prop: "createdAt",
                align: "center",
                formatter: function formatter(row) {
                  return _unref(formatterDate)(row.createdAt);
                }
              }, null, 8, ["formatter"])];
            }),
            _: 1
          }, 8, ["url"])];
        }),
        _: 1
      });
    };
  }
});